export default __webpack_public_path__ + "static/media/040-sailboat.3a57fd0c.png";